var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Icon, Tabs } from 'antd';
import * as _ from 'lodash';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import NumberFormat from 'react-number-format';
import services from 'src/shared/services/services';
import stores from 'src/stores/stores';
var renderFinancialYears = function (c) {
    return (c &&
        Object.keys(c).map(function (key) {
            return {
                yil: key.replace('y_', ''),
                val: c[key]
            };
        }));
};
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.companyFileCategories = [];
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        var _this = this;
        services.CompanyFileCategory.getAll().then(function (c) { return (_this.companyFileCategories = c); });
    };
    default_1.prototype.render = function () {
        var _this = this;
        var legends = [
            {
                name: 'Yatırımcı Bilgileri',
                items: [
                    { key: 'basvuruNo', name: 'Başvuru No' },
                    {
                        key: 'isIndividual',
                        name: 'Firma Türü',
                        value: function (c) { return (c ? 'Gerçek Kişi' : 'Tüzel Kişi'); }
                    },
                    { key: 'name', name: 'Firma Ünvanı' },
                    { key: 'yetkili', name: 'Yetkili Ad Soyad' },
                    { key: 'tcKimlikNo', name: 'Tc Kimlik No' },
                    { key: 'adres', name: 'Adres' },
                    { key: 'sehir', name: 'Şehir', value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; } },
                    { key: 'telefon', name: 'Telefon' },
                    { key: 'fax', name: 'Fax' },
                    { key: 'email', name: 'Email' },
                    { key: 'web', name: 'Web Adresi' },
                    { key: 'ticaretSicilNo', name: 'Ticaret / Esnaf Sicil No' },
                    { key: 'ticaretOdasi', name: 'Ticaret / Esnaf Odası' },
                    { key: 'vergiNumarasi', name: 'Vergi Numarası' },
                    { key: 'vergiDairesi', name: 'Vergi Dairesi' },
                    { key: 'sgkSicilNo', name: 'Sgk Sicil No' },
                    {
                        key: 'kayitliSermaye',
                        name: 'Kayıtlı Sermaye',
                        value: function (e) { return React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: e, displayType: 'text', prefix: "\u20BA " }); }
                    },
                    {
                        key: 'odenmisSermaye',
                        name: 'Ödenmiş Sermaye',
                        value: function (e) { return React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: e, displayType: 'text', prefix: "\u20BA " }); }
                    },
                    { key: 'adSoyad', name: 'Ad Soyad' },
                ]
            },
            {
                name: 'Finansal Bilgiler',
                items: [
                    {
                        key: 'metas.sonUcYillikCiro',
                        name: 'Son Üç Yıllık Ciro',
                        value: function (c) { return renderFinancialYears(c); }
                    },
                    {
                        key: 'metas.netKarZarar',
                        name: 'Net Kâr / Zarar',
                        value: function (c) { return renderFinancialYears(c); }
                    },
                    {
                        key: 'metas.ihracatTutari',
                        name: 'İhracat Tutarı',
                        value: function (c) { return renderFinancialYears(c); }
                    },
                    {
                        key: 'metas.kisaVeUzunVade',
                        name: 'Kısa ve Uzun Vadeli..',
                        value: function (c) { return renderFinancialYears(c); }
                    }
                ]
            },
            {
                name: 'Firma Özgeçmişi',
                items: [
                    { key: 'kurulusTarihi', name: 'Firma Kuruluş Tarihi' },
                    { key: 'yatirimTesvikBelgesiNo', name: 'Yatırım Teşnik Belgesi No' },
                    {
                        key: 'mevcutFaaliyetGosterdigiYer',
                        name: 'Firmanın Mevcut Faaliyet Gösterdiği Yer',
                        value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; }
                    },
                    { key: 'mevcutAcikAlan', name: 'Mevcut Açık Alan Büyüklüğü(m2)' },
                    { key: 'mevcutKapaliAlan', name: 'Mevcut Kapalı Alan Büyüklüğü(m2)' },
                    {
                        key: 'metas.ozgecmis.istigalAlanlariVeUretimDeneyimi',
                        name: 'Firmanın Önceki İştigal Alanları ve Üretim Deneyimi'
                    },
                    {
                        key: 'metas.ozgecmis.yerDegisiklikleriVeBuyumeAsamalari',
                        name: 'Firmanın Geçmişteki Yer Değişiklikleri ve Büyüme Aşamaları'
                    },
                    {
                        key: 'metas.ozgecmis.ihracatYapilanEsasUlkelerUrunler',
                        name: 'İhracat Yapılan Esas Ülkeler & Ürünler'
                    },
                    {
                        key: 'metas.ozgecmis.firmayaAitTescilliMarkalar',
                        name: 'Firmaya ait Tescilli Markalar, Patentler, Faydalı Modeller'
                    },
                    {
                        key: 'metas.ozgecmis.firmaninPazarlamaAltyapisi',
                        name: 'Firmanın Pazarlama Altyapısı'
                    },
                    {
                        key: 'metas.ozgecmis.argeUrunGelistirmeAltyapisi',
                        name: 'Ar-Ge ve Ürün Geliştirme Altyapısı'
                    },
                    {
                        key: 'metas.ozgecmis.referanslar',
                        name: 'Referanslar'
                    }
                ]
            },
            {
                name: 'Yatırıma İlişkin Bilgiler',
                items: [
                    {
                        key: 'yatiriminSektoruVeKonusu',
                        name: 'Yatırımın Sektörü ve Konusu',
                        value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; }
                    },
                    {
                        key: 'yatiriminCinsi',
                        name: 'Yatırım Cinsi',
                        value: function (c) { return stores.constant.get(c) && stores.constant.get(c).name; }
                    },
                    { key: 'uretilecekUrunler', name: 'Üretilecek Ürünler' },
                    { key: 'ongorulenYatirimBaslangicTarihi', name: 'Öngörülen Yatırım Başlangıç Tarihi' },
                    { key: 'ongorulenYatirimBitisTarihi', name: 'Öngörülen Yatırım Bitiş Tarihi' },
                    { key: 'ongorulenIsletmeyeGecisTarihi', name: 'Öngörülen İşletmeye Geçiş Tarihi' },
                    {
                        key: 'ongorulenIstihdamSayisiMavi',
                        name: 'Öngörülen İstihdam Sayısı',
                        value: function (c) { return (React.createElement("div", null,
                            "Mavi Yakal\u0131: ",
                            _this.props.model.ongorulenIstihdamSayisiMavi,
                            ", Beyaz Yakal\u0131: ",
                            _this.props.model.ongorulenIstihdamSayisiBeyaz,
                            ", Toplam:",
                            ' ',
                            _this.props.model.ongorulenIstihdamSayisiBeyaz + _this.props.model.ongorulenIstihdamSayisiMavi)); }
                    },
                    {
                        key: 'sabitYatirimTutariToplam',
                        name: 'Sabit Yatırım Tutarı (TL) ',
                        value: function (c) { return (React.createElement("div", null,
                            "Toplam:",
                            ' ',
                            React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: _this.props.model.sabitYatirimTutariToplam, displayType: 'text', prefix: "\u20BA " }),
                            ", \u00D6z Sermaye:",
                            ' ',
                            React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: _this.props.model.sabitYatirimTutariOz, displayType: 'text', prefix: "\u20BA " }),
                            ", Kredi:",
                            React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: _this.props.model.sabitYatirimTutariKredi, displayType: 'text', prefix: "\u20BA " }))); }
                    },
                    { key: 'talepEdilenToplamAlan', name: 'Talep Edilen Toplam Alan (m2)' },
                    { key: 'planlananKapaliAlan', name: 'Planlanan Kapalı Alan (m2)' },
                    { key: 'metas.yatirim.yatirimaKonuProjeninKisaAnlatimi', name: 'Yatırıma Konu Projenin Kısa Anlatımı' },
                    { key: 'metas.yatirim.isletmedeOngorulenKuruluGuc', name: 'İşletmede Öngörülen Kurulu Güç' },
                    { key: 'metas.yatirim.ongorulenDogalgazTuketimi', name: 'Öngörülen doğalgaz tüketimi (m3)' },
                    { key: 'metas.yatirim.ongorulenSuTuketimi', name: 'Öngörülen su tüketimi (m3)' },
                    { key: 'metas.yatirim.tesisOztuketimiIcınYenilenebilirEnerji', name: 'Tesis Öztüketimi için Yenilenebilir Enerji Yatırımı Düşünülüyor mu?' },
                    { key: 'metas.yatirim.yatirimCedGerektirecekMi', name: 'Yatırım ÇED Gerektirecek mi?Çevresel Açıdan Olası Etkiler' },
                    { key: 'metas.yatirim.yatiriminYanSanayiOlusturmaEtkisi', name: 'Yatırımın Yan Sanayi Oluşturma Etkisi' },
                    { key: 'metas.yatirim.yatiriminizinEtkileyecegiSektorler', name: 'Yatırımınızın doğrudan etkileyeceği/tetikleyeceği diğer sektörler' },
                    { key: 'metas.yatirim.osbdeTahsisTalebiGerekceleri', name: 'OSB de tahsis talebinin gerekçeleri' }
                ]
            }
        ];
        return (React.createElement(Tabs, { defaultActiveKey: "1", className: "ant-tab-mini" },
            this.props.prepend,
            React.createElement(Tabs.TabPane, { key: this.props.startKey + 1, tab: "YATIRIMCI B\u0130LG\u0130LER\u0130" },
                legends
                    .filter(function (x) { return x.name === 'Yatırımcı Bilgileri'; })
                    .map(function (legend, i) { return (React.createElement("div", { key: i },
                    React.createElement("table", { className: "basvuru-detay-table table table-bordered" },
                        React.createElement("tbody", null, legend.items.map(function (field) { return (React.createElement("tr", { key: field.key },
                            React.createElement("th", { className: "bg-slate-300", style: { width: '200px' } }, field.name),
                            React.createElement("td", null, field.value ? field.value(_.get(_this.props.model, field.key)) : _.get(_this.props.model, field.key)))); }))))); }),
                !this.props.model.isIndividual && (React.createElement("div", null,
                    React.createElement("h4", { style: { marginTop: '20px' } }, "\u015Eirket Ortaklar\u0131"),
                    React.createElement("table", { className: "table table-bordered" },
                        React.createElement("tr", null,
                            React.createElement("th", { className: "bg-slate-300" }, "Ad Soyad / \u00DCnvan"),
                            React.createElement("th", { className: "bg-slate-300" }, "Tc Kimlik / Ticaret Sicil No"),
                            React.createElement("th", { className: "bg-slate-300" }, "Vergi Numaras\u0131"),
                            React.createElement("th", { className: "bg-slate-300" }, "Vergi Dairesi"),
                            React.createElement("th", { className: "bg-slate-300" }, "Uyru\u011Fu"),
                            React.createElement("th", { className: "bg-slate-300" }, "Hisse Oran\u0131 (%)"),
                            React.createElement("th", { className: "bg-slate-300" }, "Hisse Tutar\u0131 (TL)")),
                        this.props.model.partners &&
                            this.props.model.partners.length > 0 &&
                            this.props.model.partners.map(function (item) { return (React.createElement("tr", { key: item.id },
                                React.createElement("td", null, item.name),
                                React.createElement("td", null, item.ticaretSicilNo),
                                React.createElement("td", null, item.vergiNumarasi),
                                React.createElement("td", null, item.vergiDairesi),
                                React.createElement("td", null, item.uyruk),
                                React.createElement("td", null, item.hisseOrani),
                                React.createElement("td", null, item.hisseTutari))); })))),
                React.createElement("h4", { style: { marginTop: '20px' } }, "Yetkili Ki\u015Filer"),
                React.createElement("table", { className: "table table-bordered" },
                    React.createElement("tr", null,
                        React.createElement("th", { className: "bg-slate-300" }, "Ad\u0131 Soyad\u0131"),
                        React.createElement("th", { className: "bg-slate-300" }, "Telefon"),
                        React.createElement("th", { className: "bg-slate-300" }, "Cep Telefonu"),
                        React.createElement("th", { className: "bg-slate-300" }, "E Posta"),
                        React.createElement("th", { className: "bg-slate-300" }, "G\u00F6rev"),
                        React.createElement("th", { className: "bg-slate-300" }, "Adres")),
                    this.props.model.contacts &&
                        this.props.model.contacts.length > 0 &&
                        this.props.model.contacts.map(function (item) { return (React.createElement("tr", { key: item.id },
                            React.createElement("td", null, item.name),
                            React.createElement("td", null, item.telefon),
                            React.createElement("td", null, item.telefonCep),
                            React.createElement("td", null, item.email),
                            React.createElement("td", null, item.gorev),
                            React.createElement("td", null, item.adres))); }))),
            React.createElement(Tabs.TabPane, { key: this.props.startKey + 2, tab: "F\u0130NANSAL B\u0130LG\u0130LER" }, legends
                .filter(function (x) { return x.name === 'Finansal Bilgiler'; })
                .map(function (legend, i) {
                return (React.createElement("div", { key: i },
                    React.createElement("table", { className: "basvuru-detay-table table table-bordered" },
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("th", null),
                                _this.props.model.years &&
                                    _this.props.model.years.map(function (year) { return (React.createElement("td", { key: year, className: "bg-slate-300" }, year)); })),
                            legend.items.map(function (field) {
                                var val = _.get(_this.props.model, field.key);
                                return (React.createElement("tr", { key: field.key },
                                    React.createElement("th", { className: "bg-slate-300", style: { width: '200px' } }, field.name),
                                    _this.props.model.years &&
                                        _this.props.model.years.map(function (year) { return (React.createElement("td", { key: year },
                                            React.createElement(NumberFormat, { thousandSeparator: ".", decimalSeparator: ",", decimalScale: 2, value: _.get(val, 'y_' + year), displayType: 'text', prefix: "\u20BA" }))); })));
                            })))));
            })),
            React.createElement(Tabs.TabPane, { key: this.props.startKey + 3, tab: "F\u0130RMA \u00D6ZGE\u00C7M\u0130\u015E\u0130" }, legends
                .filter(function (x) { return x.name === 'Firma Özgeçmişi'; })
                .map(function (legend, i) { return (React.createElement("div", { key: i },
                React.createElement("table", { className: "basvuru-detay-table table table-bordered" },
                    React.createElement("tbody", null, legend.items.map(function (field) { return (React.createElement("tr", { key: field.key },
                        React.createElement("th", { className: "bg-slate-300", style: { width: '200px' } }, field.name),
                        React.createElement("td", null, field.value ? field.value(_.get(_this.props.model, field.key)) : _.get(_this.props.model, field.key)))); }))))); })),
            React.createElement(Tabs.TabPane, { key: this.props.startKey + 4, tab: "YATIRIMA \u0130L\u0130\u015EK\u0130N B\u0130LG\u0130LER" }, legends
                .filter(function (x) { return x.name === 'Yatırıma İlişkin Bilgiler'; })
                .map(function (legend, i) { return (React.createElement("div", { key: i },
                React.createElement("table", { className: "basvuru-detay-table table table-bordered" },
                    React.createElement("tbody", null, legend.items.map(function (field) { return (React.createElement("tr", { key: field.key },
                        React.createElement("th", { className: "bg-slate-300", style: { width: '200px' } }, field.name),
                        React.createElement("td", null, field.value ? field.value(_.get(_this.props.model, field.key)) : _.get(_this.props.model, field.key)))); }))))); })),
            React.createElement(Tabs.TabPane, { key: this.props.startKey + 5, tab: "BA\u015EVURU EKLER\u0130" },
                React.createElement("div", { style: { marginBottom: 20 } },
                    React.createElement("div", { style: { paddingLeft: '2px', paddingBottom: '20px' } },
                        React.createElement(Button, { type: "primary", target: "_blank", href: location.origin + '/api/guest/guestcompanyservice/pdf?id=' + this.props.model.id + '&token=' + this.props.model.token },
                            React.createElement(Icon, { type: "download" }),
                            " BA\u015EVURU FORMUNU \u0130ND\u0130R"),
                        React.createElement(Button, { type: "primary", target: "_blank", href: location.origin + '/api/common/companyservice/downloadFiles/' + this.props.model.id, style: { marginLeft: '10px' } },
                            React.createElement(Icon, { type: "download" }),
                            " T\u00DCM EKLER\u0130 \u0130ND\u0130R")),
                    React.createElement("div", { className: "row", style: { padding: '2px' } }, this.props.model.files &&
                        this.companyFileCategories.map(function (category) { return (React.createElement("div", { className: "col-md-6", key: category.id },
                            React.createElement("div", { className: "card" },
                                React.createElement("div", { className: "card-header bg-secondary", style: { padding: '6px 10px' } },
                                    React.createElement("div", { className: "card-title" }, category.name)),
                                React.createElement("ul", { className: "list-group list-group-flush border-top" }, _this.props.model.files
                                    .filter(function (c) { return c.categoryId === category.id; })
                                    .map(function (item) { return (React.createElement("a", { href: location.origin + '/uploads/' + item.companyId + '-' + item.id + item.extension, style: { padding: '6px 10px', borderRadius: '0' }, target: "_blank", key: item.id, className: "list-group-item list-group-item-action legitRipple" },
                                    React.createElement("span", { className: "font-weight-semibold" },
                                        " ",
                                        item.name),
                                    React.createElement("span", { className: "ml-auto" },
                                        React.createElement("i", { style: { color: '#2196f3' }, className: "icon-download4 mr-2" })))); }))))); })))),
            this.props.append));
    };
    __decorate([
        observable
    ], default_1.prototype, "companyFileCategories", void 0);
    default_1 = __decorate([
        observer
    ], default_1);
    return default_1;
}(React.Component));
export default default_1;



//////////////////
// WEBPACK FOOTER
// ./src/app/common/company/DetailTabs.tsx
// module id = 525
// module chunks = 0